import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute top-0 left-0" }

import { useEventBus } from '@vueuse/core'

/*
 * generic knowledge base handling, called via eventBus,
 * emits event to be handled upstream by service-specific implementation
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'KnowledgeBase',
  emits: ["openArticle"],
  setup(__props, { emit }: { emit: ({
  (e: 'openArticle', id: string): void
}), expose: any, slots: any, attrs: any }) {

const openKnowledgeBaseBus = useEventBus('open-article')


openKnowledgeBaseBus.on((id: unknown) => {
  const idProxy = id as string
  emit('openArticle', idProxy)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})